module.exports = __webpack_public_path__ + "static/media/sound-success.78dccfdb.mp3";